export const setCursor = (cursorState) => ({
    type: 'SET_CURSOR',
    cursorState
})

export default {
    setCursor
}